import { SignatureType } from '@dealstack/shared/lib/generated';

/**
 * Whether a document can be witnessed. Wet ink can only print witness fields on a generated
 * signature page, which only a shared copy (individualInstances === false) produces.
 */
export const supportsWitnessField = ({
	signatureType,
	individualInstances,
}: {
	signatureType: SignatureType;
	individualInstances: boolean;
}): boolean => signatureType !== SignatureType.WET_INK || individualInstances === false;
